var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeAgilizeSeusCalculosPeloCelularAgger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0Celular{fill:#005b87;}\r\n\t.st1Celular{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    className: "st0Celular",
    d: "M25,0C11.2,0,0,11.2,0,25s11.2,25,25,25s25-11.2,25-25S38.8,0,25,0"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    className: "st1Celular",
    d: "M28.3,24.5h-0.6c-0.8,0-1.4-0.6-1.4-1.4v-0.6h-6.8c-0.3,0-0.5-0.2-0.4-0.5 c0-0.2,0.2-0.4,0.4-0.4h6.8V21c0-0.8,0.6-1.4,1.4-1.4h0.6c0.8,0,1.4,0.6,1.4,1.4v0.6h0.9c0.3,0,0.5,0.2,0.4,0.5 c0,0.2-0.2,0.4-0.4,0.4h-0.9v0.6C29.7,23.9,29,24.5,28.3,24.5z M27.6,20.7c-0.2,0-0.4,0.2-0.4,0.4v2.1c0,0.2,0.2,0.4,0.4,0.4h0.6 c0.2,0,0.4-0.2,0.4-0.4V21c0-0.2-0.2-0.4-0.4-0.4H27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    className: "st1Celular",
    d: "M23,29.7h-0.6c-0.8,0-1.4-0.6-1.4-1.4v-0.6h-1.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5 h1.5v-0.6c0-0.8,0.6-1.4,1.4-1.4H23c0.8,0,1.4,0.6,1.4,1.4v0.6h6.2c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5h-6.2v0.6 C24.4,29,23.7,29.7,23,29.7z M22.4,25.8c-0.2,0-0.4,0.2-0.4,0.4v2.1c0,0.2,0.2,0.4,0.4,0.4H23c0.2,0,0.4-0.2,0.4-0.4l0,0v-2.1 c0-0.2-0.2-0.4-0.4-0.4l0,0H22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    className: "st1Celular",
    d: "M23,19.4h-0.6c-0.8,0-1.4-0.6-1.4-1.4v-0.6h-1.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5 h1.5v-0.6c0-0.8,0.6-1.4,1.4-1.4H23c0.8,0,1.4,0.6,1.4,1.4v0.6h6.2c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5h-6.2V18 C24.4,18.8,23.7,19.4,23,19.4z M22.4,15.6c-0.2,0-0.4,0.2-0.4,0.4V18c0,0.2,0.2,0.4,0.4,0.4H23c0.2,0,0.4-0.2,0.4-0.4l0,0v-2.1 c0-0.2-0.2-0.4-0.4-0.4l0,0H22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_10",
    className: "st1Celular",
    d: "M25,40.2c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3c0,0,0,0,0,0 C23.7,39.6,24.3,40.2,25,40.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_12",
    className: "st1Celular",
    d: "M31.6,43H18.4c-1.8,0-3.3-1.5-3.3-3.3V10.3C15,8.4,16.5,7,18.4,7h13.3c1.8,0,3.3,1.5,3.3,3.3 v29.4C35,41.6,33.5,43,31.6,43z M16.5,36.2v3.5c0,1,0.8,1.8,1.8,1.8c0,0,0,0,0,0h13.3c1,0,1.8-0.8,1.8-1.8c0,0,0,0,0,0v-3.5H16.5 z M18.4,8.4c-1,0-1.8,0.8-1.8,1.8c0,0,0,0,0,0v24.4h17V10.3c0-1-0.8-1.8-1.8-1.8c0,0,0,0,0,0H18.4z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeAgilizeSeusCalculosPeloCelularAgger);
export default __webpack_public_path__ + "static/media/icone-agilize-seus-calculos-pelo-celular-agger.7b3f9e31b18fd931ab41969002e85095.svg";
export { ForwardRef as ReactComponent };